import { useBootstrap } from '@/store/bootstrap'
import { permMiddleware } from '@/router/guards/permissions'
import { validateRouteMiddleware } from '@/router/guards/validateRoute'
import { useCompany } from '@/store/company'
import { useWallets } from '@/store/wallets'
import { useReports } from '@/store/reports'
import { useNotifications } from '@/store/notifications'
import { useFeatures } from '@/store/features'
import { useAuthSessions } from '@/store/authSessions.js'
import { useBeneficiaries } from '@/store/beneficiaries.js'
import { useUser } from '@/store/user'
import { useOob } from '@/store/oob'

const loadAuthenticatedData = () => [
  useCompany().init(),
  useWallets().getList(),
  useBeneficiaries().getList(),
  useReports().getReports(),
  useFeatures().getFeatures(),
  useNotifications().getNotificationsInfo(),
  useAuthSessions().getSessions(),
  useOob().fetchRequests(),
]

let reloadRequest = null

/**
 * Reload global stores loaded on bootstrap.
 * Concurrent calls share one request, failed requests don't break the others.
 * @returns {Promise<void>}
 */
export const reloadAuthenticatedData = () => {
  if (reloadRequest) {
    return reloadRequest
  }

  reloadRequest = Promise.allSettled([
    useUser().getUser(),
    ...loadAuthenticatedData(),
  ])
    .then((results) => {
      results
        .filter(({ status }) => status === 'rejected')
        .forEach(({ reason }) => console.error(reason))
    })
    .finally(() => {
      reloadRequest = null
    })

  return reloadRequest
}

export const validateAppRoute = async (to) => {
  // The layout performs these checks after its initial bootstrap, before
  // mounting router-view. Once ready, regular navigation uses this guard.
  if (to.meta.requireBootstrap && !useBootstrap().isReady) return
  return permMiddleware(to) || (await validateRouteMiddleware(to))
}
